/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update Campsite Geometry Schema
 * @export
 * @interface UpdateCampsiteGeometryRequest
 */
export interface UpdateCampsiteGeometryRequest {
    /**
     * Campsite GeoJSON
     * @type {string}
     * @memberof UpdateCampsiteGeometryRequest
     */
    campsiteGeojson: string;
}

/**
 * Check if a given object implements the UpdateCampsiteGeometryRequest interface.
 */
export function instanceOfUpdateCampsiteGeometryRequest(value: object): value is UpdateCampsiteGeometryRequest {
    if (!('campsiteGeojson' in value) || value['campsiteGeojson'] === undefined) return false;
    return true;
}

export function UpdateCampsiteGeometryRequestFromJSON(json: any): UpdateCampsiteGeometryRequest {
    return UpdateCampsiteGeometryRequestFromJSONTyped(json, false);
}

export function UpdateCampsiteGeometryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCampsiteGeometryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'campsiteGeojson': json['campsite_geojson'],
    };
}

export function UpdateCampsiteGeometryRequestToJSON(value?: UpdateCampsiteGeometryRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'campsite_geojson': value['campsiteGeojson'],
    };
}

